/**
 * @license Copyright (c) 2023-2025, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md.
 */

import { CKEDITOR5_VERSION } from '@ckeditor/ckeditor5-metadata';
import type { CKEditor5PackageName } from './types';

export function getCKEditorZipUrl( packageName: CKEditor5PackageName ): string {
	return `https://cdn.ckeditor.com/${ packageName }/${ CKEDITOR5_VERSION }/zip/${ packageName }-${ CKEDITOR5_VERSION }.zip`;
}
